export const products = [
  {
    id: 1,
    name: "VoltYard 40V Brushless Mower",
    price: 349.99,
    rating: 4.8,
    reviews: 124,
    image: "https://images.unsplash.com/photo-1592424001806-53818e19c086?auto=format&fit=crop&q=80&w=600",
    description: "21-inch steel deck, dual battery port, self-propelled.",
    category: "Lawn Care"
  },
  {
    id: 2,
    name: "20V String Trimmer & Edger",
    price: 129.99,
    rating: 4.6,
    reviews: 89,
    image: "https://images.unsplash.com/photo-1622312693821-2e6840742d13?auto=format&fit=crop&q=80&w=600",
    description: "Telescopic shaft, auto-feed head, 13-inch cutting swath.",
    category: "Trimming"
  },
  {
    id: 3,
    name: "40V Jet Sweep Blower",
    price: 159.99,
    rating: 4.9,
    reviews: 210,
    image: "https://images.unsplash.com/photo-1616058055627-9092496a7d18?auto=format&fit=crop&q=80&w=600",
    description: "600 CFM, variable speed trigger, cruise control.",
    category: "Cleanup"
  },
  {
    id: 4,
    name: "20V Hedge Master 22\"",
    price: 99.99,
    rating: 4.5,
    reviews: 65,
    image: "https://images.unsplash.com/photo-1589123053646-4cb1eb68ddb1?auto=format&fit=crop&q=80&w=600",
    description: "Dual-action blades, wrap-around handle, anti-jam tech.",
    category: "Tree & Shrub"
  }
];

export const starterKits = [
  {
    id: "k1",
    name: "The Weekend Warrior Bundle",
    price: 429.99,
    originalPrice: 479.98,
    items: ["40V Mower", "20V String Trimmer", "1x 4.0Ah Battery", "Charger"],
    image: "https://images.unsplash.com/photo-1558904541-efa843a96f09?auto=format&fit=crop&q=80&w=600"
  },
  {
    id: "k2",
    name: "Fall Cleanup Pro Kit",
    price: 289.99,
    originalPrice: 339.97,
    items: ["40V Blower", "40V 14\" Chainsaw", "2x 2.0Ah Batteries", "Dual Charger"],
    image: "https://images.unsplash.com/photo-1502082553048-f009c37129b9?auto=format&fit=crop&q=80&w=600"
  }
];

export const tasks = [
  { id: 't1', title: "Lawn Mowing", icon: "FiSun" },
  { id: 't2', title: "Trimming & Edging", icon: "FiScissors" },
  { id: 't3', title: "Leaf Cleanup", icon: "FiWind" },
  { id: 't4', title: "Tree & Hedge", icon: "FiMaximize" },
];

export const comparisonData = [
  {
    feature: "Deck Size",
    modelA: "21-inch Steel",
    modelB: "19-inch Poly"
  },
  {
    feature: "Drive System",
    modelA: "Self-Propelled RWD",
    modelB: "Push"
  },
  {
    feature: "Battery Ports",
    modelA: "Dual (Active)",
    modelB: "Single"
  },
  {
    feature: "Runtime",
    modelA: "Up to 60 mins",
    modelB: "Up to 45 mins"
  }
];

export const faqs = [
  {
    q: "Are VoltYard 20V batteries compatible with 40V tools?",
    a: "No, 20V and 40V systems are separate to ensure optimal power delivery. However, our 40V dual-port chargers can charge two batteries simultaneously."
  },
  {
    q: "What is the warranty on VoltYard tools?",
    a: "We offer an industry-leading 5-year limited warranty on all bare tools and a 3-year warranty on batteries and chargers."
  },
  {
    q: "How long does shipping take?",
    a: "Standard shipping takes 3-5 business days. Heavy items like mowers ship via freight and may take 5-7 business days."
  }
];

export const reviews = [
  { id: 1, name: "Mark R.", rating: 5, text: "The 40V mower cut through my overgrown yard like butter. Highly recommend!", tool: "40V Brushless Mower" },
  { id: 2, name: "Sarah J.", rating: 4, text: "Blower is super powerful. A bit heavy with the 4Ah battery, but gets the job done fast.", tool: "40V Jet Sweep Blower" },
  { id: 3, name: "Dave T.", rating: 5, text: "Switched from gas to VoltYard. Never looking back. The Weekend Warrior kit is perfect.", tool: "Weekend Warrior Bundle" }
];